import { ILineMetrics } from '../../../interfaces';

export const getLineHeightVectorized = ({ actualBoundingBoxAscent, actualBoundingBoxDescent }: ILineMetrics): number =>
  actualBoundingBoxAscent + actualBoundingBoxDescent;
